"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeBranchPredicateString = void 0;
const exceptions_1 = require("../exceptions");
const hash_util_non_native_1 = require("./hash-util-non-native");
/**
 * Used to normalize branchPredicate string used for kahba.branch conditional and reducer router, switch
 * eg, "Some name" becomes "some.name" or sha256 of that.
 *
 * todo: move tests from handy.reducer-task-support.branch-predicate.test.ts
 *

 * @param authorPredicate
 * @param opts
 */
function normalizeBranchPredicateString(authorPredicate, opts = {}) {
    if (!authorPredicate || typeof authorPredicate !== 'string' || !authorPredicate.length) {
        throw new exceptions_1.PlusPlusPlus('InvalidPredicateString', { reason: 'authorPredicate is a required string (eg, reducer action type or conditional switch)', authorPredicate });
    }
    let branchPredicate = authorPredicate.trim().toLowerCase().replace(/[^a-z0-9]+/gi, '_').replace(/_+/g, '_');
    // permit/rm or restore:
    // if (branchPredicate.charAt(0) === '_') {
    //   branchPredicate = branchPredicate.substring(1);
    // }
    if (branchPredicate.charAt(branchPredicate.length - 1) === '_') {
        branchPredicate = branchPredicate.slice(0, -1);
    }
    if (!branchPredicate.length) {
        throw new exceptions_1.PlusPlusPlus('InvalidPredicateString', {
            reason: 'expecting some alphanumeric characters',
            authorPredicate,
        });
    }
    if (opts.shaHash) {
        branchPredicate = hash_util_non_native_1.sha256_nonNative(branchPredicate);
    }
    return branchPredicate;
}
exports.normalizeBranchPredicateString = normalizeBranchPredicateString;
//# sourceMappingURL=normalize-predicate-util.js.map